import React from 'react';

import ThankYouImage from '../assets/ThankYouImage';

type MyComponentProps = { currentRating: number };

const ThankYou: React.FC<MyComponentProps> = props => {
	const { currentRating } = props;

	return (
		<>
			<div className='flex justify-center mt-[10px]'>
				<ThankYouImage />
			</div>
			<div className='bg-dark-blue rounded-full text-orange-custom text-sm leading-6 mt-6 mx-auto mb-0 pt-[6px] px-3 pb-[5px] text-center w-fit md:mt-9 md:text-base md:leading-6'>{`You selected ${currentRating} out of 5`}</div>
			<h1 className='mt-7 text-white text-center text-2xl leading-8 md:mt-9 md:text-3xl md:leading-9'>
				Thank you!
			</h1>
			<p className='mt-3 text-custom-light-gray text-sm text-center leading-6 md:mt-3 md:text-base md:leading-6'>
				We appreciate you taking the time to give a rating. If you ever need more support,
				don't hesitate to get in touch!
			</p>
		</>
	);
};

export default ThankYou;
